/// <amd-module name="Pipeline/Analytics/PipelineDurationCommon/PipelineDurationInsights" />
import * as Resources from "Pipeline/Analytics/PipelineDurationCommon/Resources";
import { localeFormat } from "VSS/Core/Util/String";

export class PipelineDurationInsights {
    public getPipelineDurationInsights(durationTaskPercentage: number | undefined, durationTaskDiaplayName: string): string {
        if (durationTaskPercentage && durationTaskDiaplayName) {
            return localeFormat(
                Resources.MaxDurationTaskLabel,
                durationTaskPercentage + Resources.Percentage,
                "<span style='font-style: italic'>" + durationTaskDiaplayName + "</span>"
            );
        } else {
            return "";
        }
    }
}
